import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { countryCodeToEmoji } from "./countries";
import { PlayerAvatar } from "./PlayerAvatar";
import { isPlayerSummary, playerSummaryName } from "./utils";
/**
 * Shared team-page player row: whole row links to the player, showing a
 * nationality flag + name next to the avatar. `leading` fills an optional
 * slot before the avatar (e.g. a squad number); `trailing` fills an optional
 * slot at the end of the row (e.g. match goal/card glyphs).
 */
export const PlayerListRow = ({ player, leading, trailing, showDivider = false, }) => {
    const summary = isPlayerSummary(player);
    const name = playerSummaryName(player);
    return (_jsx(Link, { to: `/players/${player.id}/`, style: { textDecoration: "none", color: "inherit" }, children: _jsxs(Box, { sx: {
                py: 1.5,
                px: 2,
                display: "flex",
                alignItems: "center",
                "&:hover": { backgroundColor: "#f8f9ff" },
                transition: "all 0.2s ease",
                borderBottom: showDivider ? "1px solid rgba(0,0,0,0.08)" : "none",
            }, children: [leading, summary ? (_jsx(PlayerAvatar, { playerId: player.id, name: player.name, pictureUrl: player.picture, size: 40 })) : (_jsx(PlayerAvatar, { player: player, size: 40 })), _jsx(Box, { sx: { ml: 2, flex: 1, minWidth: 0 }, children: _jsxs(Typography, { variant: "body1", sx: { fontWeight: 600 }, children: [player.nationality
                                ? `${countryCodeToEmoji(player.nationality)} `
                                : "", name] }) }), trailing && _jsx(Box, { sx: { ml: 1, flexShrink: 0 }, children: trailing })] }) }));
};
